// Faithful, minimal SVG of the Prulo Media brand mark.
// Two equally-sized solid halves inside a hairline outline.
// LEFT: black block, white "PRULO"   RIGHT: white block, black "MEDIA"
export default function PruloLogo({ className = "", height = 44 }) {
  return (
    <svg
      viewBox="0 0 340 84"
      role="img"
      aria-label="Prulo Media"
      className={className}
      style={{ height, width: "auto" }}
      preserveAspectRatio="xMidYMid meet"
    >
      {/* Right white block */}
      <rect x="170" y="0" width="170" height="84" fill="#ffffff" />
      {/* Left black block */}
      <rect x="0" y="0" width="170" height="84" fill="#000000" />
      {/* Hairline outer border */}
      <rect
        x="0.75"
        y="0.75"
        width="338.5"
        height="82.5"
        fill="none"
        stroke="#ffffff"
        strokeOpacity="0.9"
        strokeWidth="1.5"
      />
      {/* PRULO */}
      <text
        x="85"
        y="55"
        textAnchor="middle"
        fontFamily="Outfit, sans-serif"
        fontWeight="800"
        fontSize="38"
        letterSpacing="0.06em"
        fill="#ffffff"
      >
        PRULO
      </text>
      {/* MEDIA */}
      <text
        x="255"
        y="55"
        textAnchor="middle"
        fontFamily="Outfit, sans-serif"
        fontWeight="800"
        fontSize="38"
        letterSpacing="0.06em"
        fill="#000000"
      >
        MEDIA
      </text>
    </svg>
  );
}
